module.exports = __webpack_public_path__ + "img/ai-img-logo2.f13854c0.png";